module.exports = __webpack_public_path__ + "static/media/light-ceiling.5d895253.svg";